export default {
  INFO: 'INFO',
  ERROR: 'ERROR',
}



// WEBPACK FOOTER //
// ./src/constants/topBarNotificationTypes.js